import { Pipe, PipeTransform } from '@angular/core';

// Retorna a URL CANÔNICA do evento — slug amigável (`event.uri`) quando
// disponível, fallback pro id numérico (`/events/{id}`) caso contrário.
// Use em qualquer `[routerLink]` que apontava pra `'/events/' + event.id`.
//
//   <a [routerLink]="event | eventUrl">…</a>
//
// Pra subrotas (ex.: `submit/track`), concatene o resultado como array:
//
//   <a [routerLink]="[(event | eventUrl), 'something']">…</a>
@Pipe({ name: 'eventUrl' })
export class EventUrlPipe implements PipeTransform {
  transform(event: { id?: number | string; uri?: string } | number | string | null | undefined): string {
    if (event === null || event === undefined) { return '/'; }
    // Aceita id cru (number/string) — sem como descobrir o slug; cai no /events/{id}.
    if (typeof event === 'number' || typeof event === 'string') {
      return '/events/' + event;
    }
    if (event.uri) { return '/' + event.uri; }
    return '/events/' + event.id;
  }
}
